import { Button } from '@/app/ui/components/button';
import { cn } from '@/app/utils/helpers';
import { type ErrorComponentProps, useRouter } from '@tanstack/react-router';
import { createPortal } from 'react-dom';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

interface Props extends Omit<ErrorComponentProps, 'reset' | 'error'>, React.ComponentProps<'div'> {
  reset?: () => void;
  error?: Error;
}

export function ErrorComponent({ error, reset, className, ...props }: Props) {
  const router = useRouter();

  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <div className={cn('flex grow flex-col items-center py-10 text-center', className)} {...props}>
      <div>
        <h1 className="mb-3 text-xl">Something went wrong</h1>
        <p className="mb-4 text-balance font-medium text-red-9 text-sm">
          {'We are having technical difficulties. Please, try again.'}
        </p>
        <Button
          // variant={"secondary"}
          onClick={() => {
            if (reset) return reset();
            router.invalidate();
          }}
        >
          Try again
        </Button>
      </div>
      {import.meta.env.DEV && error
        ? createPortal(
            <div className="fixed right-4 bottom-4 mx-auto mt-12 max-h-100 w-full max-w-150 overflow-auto rounded-md border border-neutral bg-surface-3 p-4 text-left">
              <h2 className="mb-2 text-lg text-red-9">Error</h2>
              {error.message}
            </div>,
            document.body,
          )
        : null}
    </div>
  );
}
